import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '../components/ui/dialog';
import { Drawer, DrawerContent, DrawerTitle } from '../components/ui/drawer';
import ModalCloseButton from '../components/generic/ModalCloseButton';
import { Button } from '../components/ui/button';
import { useMediaQuery } from '../utils/screenWidth';
import { openBannerLink } from './bannerLinkUtils';

const titleClassName = 'text-xl font-semibold text-[var(--q3-neutral-default)] mb-4 pr-2 text-center';

const BannerModalBody = ({ modalDetails, onClose, navigate, isDesktop }) => {
  const buttonUrl = modalDetails.buttonUrl?.trim();
  const TitleComponent = isDesktop ? DialogTitle : DrawerTitle;

  return (
    <>
      {modalDetails.title && <TitleComponent className={titleClassName}>{modalDetails.title}</TitleComponent>}
      {modalDetails.description && (
        <div
          className="banner-modal-content text-[var(--q3-neutral-dim)] text-sm [&_a]:text-[var(--q3-accent-normal)] [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:mb-2 [&_li]:pb-1"
          dangerouslySetInnerHTML={{ __html: modalDetails.description }}
        />
      )}
      {modalDetails.buttonText && buttonUrl && (
        <Button
          className="mt-6 w-full rounded-full !bg-[var(--q3-danger-normal)] border-none shadow-none hover:scale-100"
          onClick={() => {
            onClose();
            openBannerLink(buttonUrl, navigate);
          }}
        >
          {modalDetails.buttonText}
        </Button>
      )}
    </>
  );
};

const DashboardBannerModal = ({ open, onOpenChange, modalDetails }) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery('(min-width: 768px)');

  if (!modalDetails) return null;

  const handleClose = () => onOpenChange(false);

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-lg bg-[var(--q3-surface-default)] [&>button]:hidden">
          <div className="relative">
            <ModalCloseButton onClick={handleClose} />
            <BannerModalBody modalDetails={modalDetails} onClose={handleClose} navigate={navigate} isDesktop />
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="px-0 py-0 bg-[var(--q3-surface-default)] border-t-0 [&>div:first-child]:bg-[var(--q3-neutral-light-v3)]">
        <div className="relative max-h-[90vh] overflow-y-auto rounded-t-3xl px-4 pb-6 pt-2">
          <ModalCloseButton onClick={handleClose} />
          <BannerModalBody modalDetails={modalDetails} onClose={handleClose} navigate={navigate} isDesktop={false} />
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default DashboardBannerModal;
